import { render, staticRenderFns } from "./AppButtonTest.vue?vue&type=template&id=1585ac5f&"
import script from "./AppButtonTest.vue?vue&type=script&lang=js&"
export * from "./AppButtonTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports